module.exports = __webpack_public_path__ + "static/media/close-sans-white.b5f53958.svg";